import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useAuthorization } from "../../auth/useAuthorization";

function ProtectedRoute({ permission, redirectTo = "/access-denied", children }) {
  const { hasPermission } = useAuthorization();

  // No permission required → always render (used as a passthrough)
  if (!permission) return children;

  // Permission check — redirect immediately on failure
  if (!hasPermission(permission)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  permission: PropTypes.string,
  redirectTo: PropTypes.string,
  children: PropTypes.node,
};

export default ProtectedRoute;
